import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

const linkClass =
  'rounded-sm underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50'

/** A catalog product's name, linked to its dashboard page when the record key is known. */
export function ProductLink({
  uuid,
  children,
  className,
}: {
  uuid?: string | null
  children: ReactNode
  className?: string
}) {
  if (!uuid) return <span className={className}>{children}</span>
  return (
    <Link className={cn(linkClass, className)} params={{ productId: uuid }} to="/products/$productId">
      {children}
    </Link>
  )
}

/** A manufacturer's name, linked to its dashboard page when the record key is known. */
export function ManufacturerLink({
  uuid,
  children,
  className,
}: {
  uuid?: string | null
  children: ReactNode
  className?: string
}) {
  if (!uuid) return <span className={className}>{children}</span>
  return (
    <Link className={cn(linkClass, className)} params={{ manuId: uuid }} to="/manufacturers/$manuId">
      {children}
    </Link>
  )
}
